module.exports = __webpack_public_path__ + "img/个人信息头像.3af95e94.png";